<template>

  <v-dialog v-model="dialogStatus"
            persistent
            max-width="500px">
    <v-card class="fill-height">
      <v-card-title>
        <v-chip
            label small
            class="ma-2"
            color="secondary"
        >
          خرید شارژ حساب
          DF-004-4
        </v-chip>
        <v-spacer/>
        <v-btn style="background-color:#be1e0b" dark icon @click.stop="closed">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-card-title>
      <v-card-text class="mt-3">
        <v-form>
          <v-row>
            <v-col
                cols="12"
                sm="12"
                md="12">
              <v-autocomplete
                  :items="buildingList"
                  v-model="pay.buildingId"
                  label="انتخاب مجتمع"
                  @change="changeBuilding"
                  dense
                  outlined
                  :error-messages="getError('buildingId')"
              />
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="12">
              <v-text-field
                  outlined
                  dense
                  type="number"
                  :error-messages="getError('countSms')"
                  v-model="pay.countSms">
                <template v-slot:label>
                  <span style="color: red;font-size:13px">*</span>
                  تعداد پیامک
                </template>
              </v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="12">
              <v-text-field
                  outlined
                  dense
                  :error-messages="getError('amount')"
                  v-model="pay.amount">
                <template v-slot:label>
                  <span style="color: red;font-size:13px">*</span>
                  مبلغ هزینه(ریال)
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-radio-group
                  v-model="row"
                  row
                  dense>
                <v-radio
                    v-if="showParsian"
                    label="پارسیان"
                    value="1">
                </v-radio>
                <v-radio
                    v-if="showBsi"
                    label="صادرات"
                    value="2">
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions dir="ltr">
          <v-btn
              :disabled="!row"
              small
              depressed
              color="primary"
              class="m-3"
              @click="payment"
          >
            پرداخت
          </v-btn>
          <v-btn
              v-if="can('manualCreditAdjustment')"
              :disabled="row"
              small
              depressed
              color="primary"
              class="m-3"
              @click="paymentManualCreditAdjustment"
          >
            اعتباری
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>

    <form id="formPay" method="post" action="https://sepehr.shaparak.ir:8080/Pay ">
      <div>
        <input id="terminalID" type="hidden" name="terminalID"/>
        <input id="token" type="hidden" name="token"/>
        <input name="getMethod" type="hidden" required="required" value="1">
        <input type="hidden" name="nationalCode" value=" nationalCode"/>
        <!--        <input type="submit" value="پرداخت " class="submit" />-->
      </div>
    </form>
  </v-dialog>


</template>

<script>
import Service_se from "./Service_se.js";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
    isEdit: {
      default: false,
    },
    model: Object,
    pay: Object,
    buildingList: Array,
    cost: Number,
  },

  data() {
    return {
      row:null,
      parsian: false,
      bsi: false,
      showParsian: false,
      showBsi: false,
    }
  },
  methods: {
    changeBuilding(key) {
      let building = this.buildingList.find(({value}) => value === key);
      this.showParsian=building.check
      this.showBsi=building.check2

    },
    totalCost() {
      if (this.pay.countSms && this.cost) {
        this.pay.amount = this.pay.countSms * this.cost;
      } else {
        this.pay.amount = 0;
      }
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    // save() {
    //   this.loading=true
    //   this.bindingErrors = []
    //
    //   Service_se.save(this.model).then(response => {
    //     if (response && response.status === 200) {
    //       this.loading=false
    //       this.$snack({type: 'success'})
    //       this.closed()
    //     }else if (response && response.response.status === 400) {
    //       this.loading=false
    //       this.bindingErrors = response.response.data;
    //     }
    //   })
    //
    // },
    closed() {
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('SMSManger')
    },
    paymentManualCreditAdjustment(){
      this.bindingErrors = []
      this.loading = true
      Service_se.payManualCreditAdjustment(this.pay).then(response=>{
            if (response && response.status === 200) {
              this.$snack({type: 'success'})
              this.loading = false
              this.closed()
            }else if (response && response.response.status === 400)  {
              this.loading = false
              this.bindingErrors = response.response.data;
            }
      })
    },
    payment: function () {
      this.loading = true


      if (this.row === "1") {
        Service_se.paySmsParsian(this.pay).then(response => {
          if (response && response.status === 200) {
            this.token = response.data.token
            if (response.data.status === "0") {
              this.$session.start()
              this.$session.flash.set('token', response.data.token)
              window.location.href = 'https://pec.shaparak.ir/NewIPG/?token=' + response.data.token
            }
          } else {
            this.loading = false
            this.bindingErrors = response.response.data;
          }
        })

      } else if (this.row === "2") {
        Service_se.paymentBsi(this.pay).then(response => {
          if (response && response.status === 200) {
            this.token = response.data.token
            this.terminalID = response.data.terminalID
            document.getElementById('terminalID').value = response.data.terminalID;
            document.getElementById('token').value = response.data.token;
            const form = document.getElementById('formPay');
            form.submit()
          } else {
            this.loading = false
            this.bindingErrors = response.response.data;
          }
        })

      }

    },

  },
  watch: {
    'pay.countSms'() {
      this.totalCost();
    }
  }


}
</script>


